import { PaginatedResponse, RequestParameters } from '../types';
import { axiosInstanceV2 } from '../axios.ts';
import { snakeCaseDictToCamelCaseDict } from '../utils.ts';
import { IReferral } from './types.ts';

export function getReferrals(params: RequestParameters): Promise<PaginatedResponse<IReferral>> {
  const searchParams = new URLSearchParams(params as Record<string, string>);
  return axiosInstanceV2
    .get(`/referral/?` + searchParams.toString())
    .then(({ data }) => snakeCaseDictToCamelCaseDict(data) as PaginatedResponse<IReferral>);
}

export function updateReferral(data: { id: number } & Record<string, unknown>) {
  return axiosInstanceV2.patch(`/referral/${data.id}/`, data);
}

export function checkReferral(payload: { agreement: number; document: string }) {
  return axiosInstanceV2.post('/referral/check/', payload).then(({ data }) => data);
}

export interface CreateReferralPayload {
  agreement: number;
  document: string;
  name?: string;
  telephone?: string;
  email?: string;
  created_from: string;
}

export function createReferral(payload: CreateReferralPayload) {
  return axiosInstanceV2.post('/referral/', payload).then(({ data }) => data);
}

